"use client";

import { UserAuthProvider } from "@/contexts/user_auth_context";

export function AuthProviders({ children }: { children: React.ReactNode }) {
	return <UserAuthProvider>{children}</UserAuthProvider>;
}
